import { SOUND_OP_INIT, SOUND_OP_SUCCESS, SOUND_OP_FAILED, SOUND_OP_RESET } from '../actions/soundManager.action';
import { AddEditSoundReducer } from '../models/soundManager.interface';

const initialState: AddEditSoundReducer = {
    soundOpInit: false,
    soundOpSuccess: false,
    soundOpError: false,
    soundOpErrorMsg: '',
    soundOpSuccessMsg: '',
}

const addEditSoundReducer = (state: AddEditSoundReducer = initialState, action: any): AddEditSoundReducer => {

    switch (action.type) {
        case SOUND_OP_INIT:
            return {
                ...state,
                soundOpInit: true,
                soundOpError: false
            }
        case SOUND_OP_SUCCESS:
            return {
                ...state,
                soundOpInit: false,
                soundOpError: false,
                soundOpSuccess: true,
                soundOpSuccessMsg: action.payload
            }
        case SOUND_OP_FAILED:
            return {
                ...state,
                soundOpInit: false,
                soundOpError: true,
                soundOpErrorMsg: action.payload
            }
        case SOUND_OP_RESET:
            return initialState
        default:
            return state;
    }
}

export default addEditSoundReducer;